import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { FloatingTooltip, FloatingTooltipContentText } from '../../../Floating'
import { WidgetContentFilesDownloadButton } from '../WidgetContentFilesDownloadButton'

import * as styles from './WidgetContentFilesImagesListItemOverlay.module.css'

function WidgetContentFilesImagesListItemOverlay({
  filename,
  loading,
  tooltip,
  tooltipProps: {
    additionalText:
      tooltipAdditionalTextKey = 'FilePreview.TooltipClickToOpenTextKey',
    ...tooltipProps
  } = EMPTY_OBJECT,
  onClickDownloadFile,
}) {
  const { t } = useTranslation()

  const overlayClassName = classNames(
    styles.WidgetContentFilesImagesListItemOverlay,
    {
      [styles.disabled]: loading,
      [styles.loading]: loading,
    }
  )

  return (
    <FloatingTooltip
      content={
        tooltip || (
          <FloatingTooltipContentText
            {...tooltipProps}
            additionalText={t(tooltipAdditionalTextKey)}
            text={filename}
          />
        )
      }
      disabled={loading}
    >
      <div className={overlayClassName}>
        <WidgetContentFilesDownloadButton
          className={styles.downloadButton}
          loading={loading}
          onClick={onClickDownloadFile}
        />
      </div>
    </FloatingTooltip>
  )
}

export default WidgetContentFilesImagesListItemOverlay
